export default __webpack_public_path__ + "static/media/FSMeridian-Medium.0326e337.woff";